{
  "hero": {
    "title": "Des histoires qui méritent d'être entendues",
    "subtitle": "Journalisme indépendant en français, anglais et arabe"
  },
  "latest": {
    "title": "Derniers articles",
    "viewAll": "Voir tous les articles",
    "backHome": "Retour à l'accueil",
    "emptyTitle": "Des histoires arrivent bientôt",
    "emptyText": "Nous préparons nos premières histoires — revenez bientôt."
  },
  "categories": {
    "all": "Tout",
    "investigation": "Enquêtes",
    "culture": "Culture",
    "opinion": "Opinion",
    "features": "Reportages",
    "video": "Vidéo"
  },
  "newsletter": {
    "title": "Restez informé",
    "description": "Recevez les dernières histoires dans votre boîte mail.",
    "placeholder": "Votre adresse email",
    "cta": "S'abonner",
    "success": "Merci de votre abonnement !",
    "error": "L'abonnement a échoué. Veuillez réessayer."
  },
  "about": {
    "title": "À propos de Beyond Silence",
    "p1": "Beyond Silence est une plateforme de journalisme indépendant trilingue publiant en français, anglais et arabe. Nous croyons que les histoires de chaque communauté méritent d'être entendues — ni réduites au silence, ni ignorées, ni perdues dans la traduction.",
    "p2": "Notre équipe de journalistes, rédacteurs et contributeurs travaille au-delà des frontières pour vous apporter des enquêtes, des reportages, des tribunes et des vidéos qui défient le statu quo et amplifient les voix sous-représentées.",
    "p3": "Beyond Silence est financé par ses lecteurs. Nous ne mettons pas de paywall et n'exigeons pas d'abonnement. Si vous appréciez notre travail, soutenez-nous via Buy Me a Coffee — chaque contribution nous aide à continuer.",
    "contactTitle": "Contactez-nous",
    "contactDesc": "Vous avez une information, souhaitez collaborer ou rejoindre notre équipe ? Écrivez-nous à contact@beyondsilence.fr. Nous lisons chaque message."
  },
  "contact": {
    "title": "Contactez-nous",
    "description": "Des questions, une information ou une envie de collaborer ? Écrivez-nous — nous lisons chaque message."
  }
}
